import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { setActivityFilter } from '../../../store/actions/activity'
import { activityFilterSelector } from '../../../store/selectors/activitySelectors'

const ActivityToolbarContainer = compose(
  connect(
    state => ({ filter: activityFilterSelector(state) }),
    { setFilter: setActivityFilter }
  ),
  withTranslation()
)

export default ActivityToolbarContainer
